<script>
  import { onMount } from 'svelte'

  export let timeout = 1000

  let mounted = false

  onMount( ()=>{
    setTimeout( () => {
      mounted = true
    }, timeout)
  })
</script>

{#if mounted}
  <slot></slot>
{/if}
